import {
  EntityFormFieldName,
  addLeadAddress,
  addLeadAltPhoneNumber,
  addLeadAssigneeId,
  addLeadCompany,
  addLeadDivisionId,
  addLeadEmailAddress,
  addLeadFirstName,
  addLeadLastName,
  addLeadLocationTypeId,
  addLeadNote,
  addLeadPhoneNumber,
  addLeadPreferredMethodOfContact,
  addLeadPreferredTimeOfContact,
  addLeadSalesFunnelStageId,
  addLeadToPestPac,
  entityCampaignId,
  entityLeadSourceId,
  entityNextActionDate,
  entityReferral,
  entitySalesFunnelId,
  entitySalesTeamId,
  entityTargetPests,
} from '../constants'
import { combineTopCards, customOrder } from './registryData'
import { findRequiredGroup } from './requiredGroups'
import { FieldConfig } from './typings'

/**
 * The fields that make up the Lead field-settings screen, in the order the
 * server seeds them.
 *
 * `order` and `combineWithNext` are computed below from the registry source
 * data at module init rather than hand-transcribed, so they cannot drift out
 * of sync with it.
 *
 * Section grouping is deliberately absent: a field's section is server-owned
 * per-record data (`IEntityFormSetting.sectionId`) and stays driven by each
 * record's own value at render time.
 */
const leadFieldIds: EntityFormFieldName[] = [
  addLeadToPestPac,
  addLeadFirstName,
  addLeadLastName,
  addLeadCompany,
  addLeadAddress,
  addLeadLocationTypeId,
  addLeadDivisionId,
  addLeadEmailAddress,
  addLeadPhoneNumber,
  addLeadAltPhoneNumber,
  addLeadPreferredMethodOfContact,
  addLeadPreferredTimeOfContact,
  entitySalesTeamId,
  addLeadAssigneeId,
  entitySalesFunnelId,
  addLeadSalesFunnelStageId,
  entityCampaignId,
  entityLeadSourceId,
  entityReferral,
  entityTargetPests,
  entityNextActionDate,
  addLeadNote,
]

export const leadFieldConfig: FieldConfig[] = leadFieldIds.map((id) => {
  const config: FieldConfig = {
    id,
    order: customOrder.indexOf(id),
    combineWithNext: combineTopCards.includes(id),
    requiredGroup: findRequiredGroup(id),
  }
  if (id === addLeadToPestPac) {
    config.renderer = 'pestPacOption'
  }
  if (id === addLeadCompany) {
    config.renderer = 'nameRequirementMode'
  }
  return config
})
